import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationEntry} from "../types/ReservationEntry";
import {ReservationPlacement} from "../types/ReservationPlacement";

interface IReservationPlacementConfig {
    // the funnel of the placement - its events, its confirmation and the `reservation_entry` of its Amplitude events
    entry: ReservationEntry;
    // the registration placement of a reservation started here; the unlock choice is opened by a registration that already has its own
    authPlacement: AmplitudeAuthPlacement | null;
    // only the buttons on the property page are lead form sections - the modals are reported under their placement
    gtmSourceSection: GTMEventApplicationSourceSection | null;
    // the button that starts the reservation - the unlock choice starts it from its option card instead
    cta: {label: string; testId: string} | null;
}

// `satisfies` keeps the per-placement types, so the button placements read their `cta` without a null check
export const RESERVATION_PLACEMENT_CONFIG = {
    sidebar: {
        entry: "cta",
        authPlacement: "rp_reservation_sidebar",
        gtmSourceSection: GTMEventApplicationSourceSection.SIDEBAR_RESERVATION,
        cta: {label: "Zarezerwuj bezpłatnie", testId: RP_RESERVATION_TEST_IDS.CTA_SIDEBAR}
    },
    contact_bar: {
        entry: "cta",
        authPlacement: "rp_reservation_contact_bar",
        gtmSourceSection: GTMEventApplicationSourceSection.STICKY_BAR_RESERVATION,
        cta: {label: "Zarezerwuj", testId: RP_RESERVATION_TEST_IDS.CTA_CONTACT_BAR}
    },
    post_lead: {
        entry: "cta",
        authPlacement: "rp_reservation_post_lead",
        gtmSourceSection: null,
        cta: {label: "Bezpłatna rezerwacja", testId: RP_RESERVATION_TEST_IDS.POST_LEAD_RESERVATION_BUTTON}
    },
    unlock_choice: {
        entry: "unlock_choice",
        authPlacement: null,
        gtmSourceSection: null,
        cta: null
    }
} satisfies Record<ReservationPlacement, IReservationPlacementConfig>;

// A request handed over to another host (e.g. after an expired session) stays in the funnel of the placement it was started from
export const getReservationEntry = (request: IReservationRequest): ReservationEntry => RESERVATION_PLACEMENT_CONFIG[request.placement].entry;
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationEntry} from "../types/ReservationEntry";
import {ReservationPlacement} from "../types/ReservationPlacement";

interface IReservationPlacementConfig {
    // the funnel of the placement - its events, its confirmation and the `reservation_entry` of its Amplitude events
    entry: ReservationEntry;
    // the registration placement of a reservation started here; the unlock choice is opened by a registration that already has its own
    authPlacement: AmplitudeAuthPlacement | null;
    // only the buttons on the property page are lead form sections - the modals are reported under their placement
    gtmSourceSection: GTMEventApplicationSourceSection | null;
    // the button that starts the reservation - the unlock choice starts it from its option card instead
    cta: {label: string; testId: string} | null;
}

// `satisfies` keeps the per-placement types, so the button placements read their `cta` without a null check
export const RESERVATION_PLACEMENT_CONFIG = {
    sidebar: {
        entry: "cta",
        authPlacement: "rp_reservation_sidebar",
        gtmSourceSection: GTMEventApplicationSourceSection.SIDEBAR_RESERVATION,
        cta: {label: "Zarezerwuj bezpłatnie", testId: RP_RESERVATION_TEST_IDS.CTA_SIDEBAR}
    },
    contact_bar: {
        entry: "cta",
        authPlacement: "rp_reservation_contact_bar",
        gtmSourceSection: GTMEventApplicationSourceSection.STICKY_BAR_RESERVATION,
        cta: {label: "Zarezerwuj", testId: RP_RESERVATION_TEST_IDS.CTA_CONTACT_BAR}
    },
    post_lead: {
        entry: "cta",
        authPlacement: "rp_reservation_post_lead",
        gtmSourceSection: null,
        cta: {label: "Bezpłatna rezerwacja", testId: RP_RESERVATION_TEST_IDS.POST_LEAD_RESERVATION_BUTTON}
    },
    unlock_choice: {
        entry: "unlock_choice",
        authPlacement: null,
        gtmSourceSection: null,
        cta: null
    }
} satisfies Record<ReservationPlacement, IReservationPlacementConfig>;

// A request handed over to another host (e.g. after an expired session) stays in the funnel of the placement it was started from
export const getReservationEntry = (request: IReservationRequest): ReservationEntry => RESERVATION_PLACEMENT_CONFIG[request.placement].entry;
